import { render, staticRenderFns } from "./YoutubeVideo.vue?vue&type=template&id=11a0aeda&"
import script from "./YoutubeVideo.vue?vue&type=script&lang=ts&"
export * from "./YoutubeVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports